import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import type { TripSummary } from '../../shared/trip-api.js';

/**
 * The open trip's editable name, with a menu to switch, create or delete trips.
 */
export function TripSwitcher({ trips, activeId, name, saved, saveLine, nameError, onNameChange, onNameCommit, onOpen, onNew, onDelete }: {
  trips: Array<Pick<TripSummary, 'id' | 'name' | 'subtripIds'>>;
  activeId: string;
  name: string;
  saved: boolean;
  saveLine: string;
  /** Why the last rename was refused. */
  nameError?: string;
  onNameChange: (name: string) => void;
  onNameCommit: () => void;
  onOpen: (id: string) => void;
  onNew: () => void;
  onDelete: () => void;
}) {
  return (
    <div className="trip-header">
      <div className="trip-title">
        <input
          className="trip-title-input"
          value={name}
          maxLength={80}
          aria-label="Trip name"
          onChange={(event) => onNameChange(event.target.value)}
          onBlur={onNameCommit}
          onKeyDown={(event) => { if (event.key === 'Enter' || event.key === 'Escape') event.currentTarget.blur(); }}
        />
        <p className={saved && !nameError ? 'trip-status' : 'trip-status trip-status-warning'} role={nameError ? 'alert' : undefined}>
          {nameError ?? saveLine}
        </p>
      </div>
      <DropdownMenu.Root>
        <DropdownMenu.Trigger className="trip-menu-button">
          Trips <span className="trip-menu-count">{trips.length}</span><span aria-hidden="true" className="trip-menu-chevron">⌄</span>
        </DropdownMenu.Trigger>
        <DropdownMenu.Portal>
          <DropdownMenu.Content className="trip-menu" align="end" sideOffset={6}>
            <DropdownMenu.Label className="trip-menu-label">Your trips</DropdownMenu.Label>
            <DropdownMenu.RadioGroup value={activeId} onValueChange={onOpen}>
              {trips.map((trip) => (
                <DropdownMenu.RadioItem key={trip.id} value={trip.id} className="trip-menu-item" textValue={trip.name}>
                  <span className="trip-menu-check"><DropdownMenu.ItemIndicator>✓</DropdownMenu.ItemIndicator></span>
                  <span className="trip-menu-name">{trip.id === activeId ? name || trip.name : trip.name}</span>
                  <span className="trip-menu-meta">{trip.subtripIds.length > 1 ? `${trip.subtripIds.length} sub-trips` : ''}</span>
                </DropdownMenu.RadioItem>
              ))}
            </DropdownMenu.RadioGroup>
            <DropdownMenu.Separator className="trip-menu-separator" />
            <DropdownMenu.Item className="trip-menu-item" onSelect={onNew}>
              <span className="trip-menu-check">+</span>New trip
            </DropdownMenu.Item>
            <DropdownMenu.Item className="trip-menu-item trip-menu-danger" onSelect={onDelete}>
              <span className="trip-menu-check" />Delete this trip
            </DropdownMenu.Item>
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      </DropdownMenu.Root>
    </div>
  );
}
